import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import { getConfigValue } from '@jutro/config';
import loadMixpanel from '../mixpanel';
import { subscribe } from '../EventProvider';
import JUTRO_TOPICS from '../jutroTopics';
import WhitelistProvider from './WhitelistProvider';
import DictionaryProvider from './DictionaryProvider';
export default (trackingConfig = {
  whitelistConfig: {},
  dictionaryConfig: {}
}) => {
  const mixpanel = loadMixpanel(getConfigValue('MIXPANEL_TRACKING_ID'));
  const whitelist = WhitelistProvider.create(trackingConfig.whitelistConfig);
  const translate = DictionaryProvider.create(trackingConfig.dictionaryConfig);
  const UNKNOWN_ERROR = JUTRO_TOPICS.UNKNOWN_ERROR,
    REST_JUTRO_TOPICS = _objectWithoutProperties(JUTRO_TOPICS, ["UNKNOWN_ERROR"]);
  subscribe(UNKNOWN_ERROR, event => mixpanel.track(UNKNOWN_ERROR, event.error));
  subscribe(REST_JUTRO_TOPICS, (event, topic) => {
    const transformedEvent = translate(whitelist(event));
    mixpanel.track(topic, transformedEvent);
  });
};